<template>
  <action-sheet
    :opened.sync="openData"
    :actionHeader="true"
    :actionFooter="false"
    class="main-action"
    @close-button-clicked="close()"
  >
    <template #content>
      <!-- 비로그인 -->
      <template v-if="!isLogin && menuKnd > 0 && menuKnd != '3'">
        <div class="info">
          <p>{{ /*로그인이 필요한 서비스입니다.*/ $t("MMAIN-03-03-03-14") }}</p>
          <button
            class="btn md normal"
            @click="goPage('-9')"
          >{{ /*로그인 하러 가기*/ $t("MMAIN-03-03-03-15") }}</button>
        </div>
      </template>
      <!-- 조회 -->
      <template v-else-if="menuKnd == '1'">
        <ul class="ulist">
          <li v-if="isLogin && siteCode ==$config.SITECODE_OGHCM">
            <div class="item icon" @click="goPage('8')">
              <i class="icon icon-main-account" />
            </div>
            <div class="item" @click="goPage('8')">{{ /*내계좌*/ $t("MMAIN-03-01-01-15") }}</div>
          </li>
          <li v-if="isLogin">
            <div class="item icon" @click="goPage('1')">
              <i class="icon icon-main-inquiry01" />
            </div>
            <div class="item" @click="goPage('1')">{{ /*거래내역*/ $t("MMAIN-03-03-02-07") }}</div>
          </li>
          <li v-if="isLogin">
            <div class="item icon" @click="goPage('2')">
              <i class="icon icon-main-inquiry02" />
            </div>
            <div class="item" @click="goPage('2')">{{ /*이체내역*/ $t("MMAIN-03-03-02-08") }}</div>
          </li>
          <!-- 2차오픈 전까지 주석처리 -->
          <!-- <li v-if="isLogin">
            <div class="item icon" @click="goPage('3')">
              <i class="icon icon-main-inquiry03" />
            </div>
            <div class="item" @click="goPage('3')">{{ /*과거대출*/ $t("MMAIN-03-03-02-09") }}</div>
          </li>-->

          <!--
          <li>
            <div class="item icon" @click="goPage('4')">
              <i class="icon icon-main-inquiry04" />
            </div>
            <div class="item" @click="goPage('4')">{{ /*환율*/ $t("MMAIN-03-03-02-10") }}</div>
          </li>
          -->

          <!-- <li>
            <div class="item icon" @click="goPage('5')">
              <i class="icon icon-main-inquiry05" />
            </div>
            <div class="item" @click="goPage('5')">환율변동</div>
          </li>
          -->
        </ul>
      </template>
      <template v-else-if="menuKnd == '2'">
        <ul class="ulist">
          <li>
            <div class="item icon" @click="goPage('1')">
              <i class="icon icon-main-tranfer01" />
            </div>
            <div class="item" @click="goPage('1')">{{ /*당행이체*/ $t("MMAIN-03-03-03-08") }}</div>
          </li>
          <li v-if="siteCode != $config.SITECODE_OGCBD">
            <div class="item icon" @click="goPage('2')">
              <i class="icon icon-main-tranfer02" />
            </div>
            <div class="item" @click="goPage('2')">{{ /*타행이체*/ $t("MMAIN-03-03-03-09") }}</div>
          </li>
          <li v-if="siteCode != $config.SITECODE_OGIND">
            <div class="item icon" @click="goPage('3')">
              <i class="icon icon-main-tranfer03" />
            </div>
            <div class="item" @click="goPage('3')">{{ /*자동이체*/ $t("MMAIN-03-03-03-10") }}</div>
          </li>
          <li v-if="false">
            <div class="item icon" @click="goPage('4')">
              <i class="icon icon-main-tranfer04" />
            </div>
            <div class="item" @click="goPage('4')">{{ /*대출상환*/ $t("MMAIN-03-03-03-11") }}</div>
          </li>
          <li v-if="siteCode != $config.SITECODE_OGIND">
            <div class="item icon" @click="goPage('5')">
              <i class="icon icon-main-tranfer05" />
            </div>
            <div class="item" @click="goPage('5')">{{ /*이자납입*/ $t("MMAIN-03-03-03-12") }}</div>
          </li>
        </ul>
      </template>
      <template v-else-if="menuKnd == '3'">
        <ul class="ulist">
          <li>
            <div class="item icon" @click="goPage('1')">
              <i class="icon icon-main-support01" />
            </div>
            <div class="item" @click="goPage('1')">{{ /*ID 찾기*/ $t("MMAIN-03-03-04-01") }}</div>
          </li>
          <li v-if="!isCorporationSubUser">
            <div class="item icon" @click="goPage('2')">
              <i class="icon icon-main-support02" />
            </div>
            <div class="item" @click="goPage('2')">{{ /*비밀번호 변경*/ $t("MMAIN-03-03-04-02") }}</div>
          </li>

          <li
            v-if="`${$config.SITECODE_OGCBD}|${$config.SITECODE_OGHCM}`.includes(siteCode) && !isCorporationUser"
          >
            <div class="item icon" @click="goPage('3')">
              <i class="icon icon-main-support03" />
            </div>
            <div class="item" @click="goPage('3')">{{ /*mOTP발급*/ $t("MMAIN-03-03-04-03") }}</div>
          </li>

          <!-- <li>
            <div class="item icon" @click="goPage('4')">
              <i class="icon icon-main-support04" />
            </div>
            <div class="item" @click="goPage('4')">{{/*사고신고*/$t("MMAIN-03-03-04-04")}}</div>
          </li>-->
          <li>
            <div class="item icon" @click="goPage('5')">
              <i class="icon icon-main-support05" />
            </div>
            <div class="item" @click="goPage('5')">{{ /*영업점 안내*/ $t("MMAIN-03-03-04-05") }}</div>
          </li>

          <li>
            <div class="item icon" @click="goPage('6')">
              <i class="icon icon-main-inquiry06" />
            </div>
            <div class="item" @click="goPage('6')">{{ /*공지/뉴스*/ $t("MMAIN-03-03-02-12") }}</div>
          </li>
          <li v-if="siteCode != $config.SITECODE_OGIND">
            <div class="item icon" @click="goPage('7')">
              <i class="icon icon-main-inquiry07" />
            </div>
            <div class="item" @click="goPage('7')">FAQ</div>
          </li>
        </ul>
      </template>
    </template>
  </action-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import ActionSheet from "@/components/page/main/ActionSheetMain";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    qrOpened: {
      type: Boolean,
      default: false,
    },
    menuKnd: {
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    ActionSheet,
  },
  data() {
    return {};
  },
  computed: {
    ...mapFields(["siteCode"]),
    ...mapGetters(["isLogin", "isCorporationSubUser", "isCorporationUser", "isUserOtpDstcd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    goPage(data) {
      let pageName = "";

      if (!this.isLogin && data == "-9") {
        pageName = "login";
      } else {
        if (this.menuKnd == "1") {
          if (data == "1") {
            //거래내역
            pageName = "transactionDetails";
          } else if (data == "2") {
            //이체내역
            if (this.siteCode == this.$config.SITECODE_OGMMR) {
              pageName = "cbmnetTrsaccRsultInq";
            } else {
              pageName = "trsaccRsultInq";
            }
          } else if (data == "3") {
            //과거대출
            pageName = "rpayRsultInq";
          } else if (data == "4") {
            //환율
            pageName = "foreignExchange";
          } else if (data == "5") {
            //환율변동
            pageName = "exrtFlxblPrgrs";
          } else if (data == "6") {
            //공지/뉴스
            pageName = "newsList";
          } else if (data == "7") {
            //FAQ
            pageName = "faq";
          } else if (data == "8") {
            //내계좌
            pageName = "accounts";
          }
        } else if (this.menuKnd == "2") {
          if (data == "1") {
            //당행이체
            pageName = "trsaccInfoInptReq";
          } else if (data == "2") {
            //타행이체
            //베트남 motp 이용자일 경우 나파스 메뉴로 이동
            if (this.siteCode == this.$config.SITECODE_OGHCM && this.isLogin && (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03")) {
              pageName = "vtnOtrbnkTrsaccInfoInptReqStep1";
            } else if (this.siteCode == this.$config.SITECODE_OGMMR && this.isLogin) {
              pageName = "cbmnetTrsaccInfoInptReqStep1";
            } else {
              pageName = "otrbnkTrsaccInfoInptReq";
            }
          } else if (data == "3") {
            //자동이체
            pageName = "autoTrsaccInfoInptReq";
          } else if (data == "4") {
            //대출상환
            pageName = "loansIn";
          } else if (data == "5") {
            //이자납입
            pageName = "loansIn";
          }
        } else if (this.menuKnd == "3") {
          if (data == "1") {
            //ID찾기
            pageName = "findId";
          } else if (data == "2") {
            //비밀번호변경
            pageName = "changePassword";
          } else if (data == "3") {
            //mOTP발급
            pageName = "createMotp";
          } else if (data == "4") {
            //사고신고
            pageName = "reportAcco unt";
          } else if (data == "5") {
            //영업점안내
            pageName = "customerCounsel";
          } else if (data == "6") {
            //공지/뉴스
            pageName = "newsList";
          } else if (data == "7") {
            //FAQ
            pageName = "faq";
          }
        }
      }

      this.$emit("click", pageName);
    },
    close() {
      this.openData = false;
      this.$emit("update:qrOpened", true);
      this.$parent.menuKnd = 0;
    },
  },
};
</script>
